// assets/sample-order-modal.js

document.addEventListener('DOMContentLoaded', function() {
  const customFieldsModal = document.getElementById('custom-fields-modal');

  // If modal HTML is not present, exit script
  if (!customFieldsModal) {
    console.log("Sample Order Modal: HTML element not found on page. Script not active.");
    return;
  }

  const modalCloseButton = customFieldsModal.querySelector('.modal-close-button');
  const modalProceedButton = document.getElementById('modal-proceed-to-checkout');

  const modalCompanyWebsiteField = document.getElementById('modal-company-website');
  const modalRoleField = document.getElementById('modal-your-role-or-position');
  const modalPurposeField = document.getElementById('modal-purpose-of-sampling');

  const modalFields = customFieldsModal.querySelectorAll('.required-modal-field');
  const modalErrorMessages = customFieldsModal.querySelectorAll('.validation-error-msg');

  // --- Modal Show/Hide Functions ---
  window.showSampleOrderModal = function() { // Expose to global scope for easy calling
    console.log("Showing custom fields modal...");
    customFieldsModal.classList.add('is-active');
    document.body.classList.add('modal-open');

    // Pre-fill fields if cart attributes already exist
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (modalCompanyWebsiteField) modalCompanyWebsiteField.value = cart.attributes["Company Website"] || '';
        if (modalRoleField) modalRoleField.value = cart.attributes["Your Role or Position"] || '';
        if (modalPurposeField) modalPurposeField.value = cart.attributes["Purpose Of Sampling"] || '';
        validateModalFields(); // Re-validate after pre-filling to update button state
      })
      .catch(error => console.error('Error fetching cart for pre-fill:', error));
  };

  window.hideSampleOrderModal = function() { // Expose to global scope
    console.log("Hiding custom fields modal...");
    customFieldsModal.classList.remove('is-active');
    document.body.classList.remove('modal-open');
    modalErrorMessages.forEach(msg => {
      msg.style.display = 'none';
      msg.removeAttribute('aria-hidden');
    });
  };

  // --- Modal Validation Function ---
  function validateModalFields() {
    let allModalFieldsValid = true;

    modalErrorMessages.forEach(msg => {
      msg.style.display = 'none';
      msg.removeAttribute('aria-hidden');
    });

    if (modalCompanyWebsiteField && modalCompanyWebsiteField.value.trim() === '') {
      allModalFieldsValid = false;
      const errorMsg = customFieldsModal.querySelector('[data-error-for="modal-company-website"]');
      if (errorMsg) { errorMsg.style.display = 'block'; errorMsg.setAttribute('aria-hidden', 'false'); }
    }

    if (modalRoleField && modalRoleField.value.trim() === '') {
      allModalFieldsValid = false;
      const errorMsg = customFieldsModal.querySelector('[data-error-for="modal-your-role-or-position"]');
      if (errorMsg) { errorMsg.style.display = 'block'; errorMsg.setAttribute('aria-hidden', 'false'); }
    }

    if (modalPurposeField && modalPurposeField.value === '') {
      allModalFieldsValid = false;
      const errorMsg = customFieldsModal.querySelector('[data-error-for="modal-purpose-of-sampling"]');
      if (errorMsg) { errorMsg.style.display = 'block'; errorMsg.setAttribute('aria-hidden', 'false'); }
    }

    if (modalProceedButton) {
      if (allModalFieldsValid) {
        modalProceedButton.removeAttribute('disabled');
        modalProceedButton.removeAttribute('aria-disabled');
      } else {
        modalProceedButton.setAttribute('disabled', 'disabled');
        modalProceedButton.setAttribute('aria-disabled', 'true');
      }
    }
    return allModalFieldsValid;
  }

  // --- Event Listeners for Modal ---
  if (modalCloseButton) {
    modalCloseButton.addEventListener('click', window.hideSampleOrderModal);
    customFieldsModal.querySelector('.modal-overlay').addEventListener('click', window.hideSampleOrderModal);
  }

  modalFields.forEach(field => {
    if (field.tagName === 'SELECT') {
      field.addEventListener('change', validateModalFields);
    } else {
      field.addEventListener('input', validateModalFields);
    }
  });

  if (modalProceedButton) {
    modalProceedButton.addEventListener('click', async function(event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      const isValid = validateModalFields();
      if (!isValid) {
        alert('Please fill in all required fields to proceed.');
        const firstError = customFieldsModal.querySelector('.validation-error-msg[style*="display: block"]');
        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstError.focus();
        }
        console.log('Modal validation failed. Stopping checkout process.');
        return;
      }

      this.setAttribute('disabled', 'disabled');
      this.setAttribute('aria-disabled', 'true');
      this.classList.add('loading'); // Add a loading class if you have CSS for it

      try {
        // Update global cart attributes with the collected custom fields
        console.log('Updating global cart attributes with:', {
          "Company Website": modalCompanyWebsiteField.value,
          "Your Role or Position": modalRoleField.value,
          "Purpose Of Sampling": modalPurposeField.value
        });
        const updateAttributesPayload = {
          attributes: {
            "Company Website": modalCompanyWebsiteField.value,
            "Your Role or Position": modalRoleField.value,
            "Purpose Of Sampling": modalPurposeField.value
          }
        };

        // Using cart/update.js for attributes
        const updateResponse = await fetch(`${routes.cart_update_url}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updateAttributesPayload)
        });

        if (!updateResponse.ok) {
          const errorDetails = await updateResponse.text();
          throw new Error(`Failed to update cart attributes: ${updateResponse.status} ${errorDetails}`);
        }
        console.log('Cart attributes successfully updated. Redirecting to checkout...');

        // Redirect to checkout after successful attribute update
        window.location.assign('/checkout');

      } catch (error) {
        console.error('Error during custom fields submission:', error);
        alert('Could not proceed to checkout. Please try again. Error: ' + error.message);
        this.removeAttribute('disabled');
        this.removeAttribute('aria-disabled');
        this.classList.remove('loading');
      }
    });
  }
});